export const DOCUMENT_REQUIREMENTS = {
  EMPLOYEE: {
    IDENTITY_FRONT: {
      required: true,
      label: "screening.profile.doc_identity_front",
      info: "screening.profile.identity_front_info",
    },
    IDENTITY_BACK: {
      required: true,
      label: "screening.profile.doc_identity_back",
      info: "screening.profile.identity_back_info",
    },
    EMPLOYER_DECLARATION: {
      required: true,
      label: "screening.profile.doc_employer_declaration",
      info: "screening.profile.employer_declaration_info",
    },
    PAYSLIP_1: {
      required: true,
      label: "screening.profile.doc_payslip_1",
      info: "screening.profile.payslip_1_info",
    },
    PAYSLIP_2: {
      required: true,
      label: "screening.profile.doc_payslip_2",
      info: "screening.profile.payslip_2_info",
    },
    PAYSLIP_3: {
      required: true,
      label: "screening.profile.doc_payslip_3",
      info: "screening.profile.payslip_3_info",
    },
    BANKCARD_COPY: {
      required: true,
      label: "screening.profile.doc_bankcard_copy",
      info: "screening.profile.bank_card_info",
    },
    LANDLORD_DECLARATION: {
      required: false,
      label: "screening.profile.doc_landlord_declaration",
      info: "screening.profile.landlord_declaration_info",
    },
    PERSONAL_RECORD: {
      required: false,
      label: "screening.profile.doc_personal_record",
      info: "screening.profile.personal_record_info",
    },
    UWV_RECORD: {
      required: false,
      label: "screening.profile.doc_uwv_record",
      info: "screening.profile.uwv_record_info",
    },
  },
  SELF_EMPLOYED: {
    IDENTITY_FRONT: {
      required: true,
      label: "screening.profile.doc_identity_front",
      info: "screening.profile.identity_front_info",
    },
    IDENTITY_BACK: {
      required: true,
      label: "screening.profile.doc_identity_back",
      info: "screening.profile.identity_back_info",
    },
    COMPANY_REGISTRATION: {
      required: true,
      label: "screening.profile.doc_company_registration",
      info: "screening.profile.company_registration_info",
    },
    INCOME_STATEMENT: {
      required: true,
      label: "screening.profile.doc_income_statement",
      info: "screening.profile.income_statement_info",
    },
    BALANCE_STATEMENT: {
      required: true,
      label: "screening.profile.doc_balance_statement",
      info: "screening.profile.balance_statement_info",
    },
    BANKCARD_COPY: {
      required: true,
      label: "screening.profile.doc_bankcard_copy",
      info: "screening.profile.bank_card_info",
    },
    LANDLORD_DECLARATION: {
      required: false,
      label: "screening.profile.doc_landlord_declaration",
      info: "screening.profile.landlord_declaration_info",
    },
    PERSONAL_RECORD: {
      required: false,
      label: "screening.profile.doc_personal_record",
      info: "screening.profile.personal_record_info",
    },
  },
  PENSION: {
    IDENTITY_FRONT: {
      required: true,
      label: "screening.profile.doc_identity_front",
      info: "screening.profile.identity_front_info",
    },
    IDENTITY_BACK: {
      required: true,
      label: "screening.profile.doc_identity_back",
      info: "screening.profile.identity_back_info",
    },
    AOW: {
      required: true,
      label: "screening.profile.doc_aow_statement",
      info: "screening.profile.aow_statement_info",
    },
    PENSION: {
      required: true,
      label: "screening.profile.doc_pension_statement",
      info: "screening.profile.pension_statement_info",
    },
    BANKCARD_COPY: {
      required: true,
      label: "screening.profile.doc_bankcard_copy",
      info: "screening.profile.bank_card_info",
    },
    LANDLORD_DECLARATION: {
      required: false,
      label: "screening.profile.doc_landlord_declaration",
      info: "screening.profile.landlord_declaration_info",
    },
    PERSONAL_RECORD: {
      required: false,
      label: "screening.profile.doc_personal_record",
      info: "screening.profile.personal_record_info",
    },
  },
} as const;
